import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_pets_cat: FaireCategoryEntity = {
  token: "cat_pets-cat",
  type: "category",
  name: "Cat",
  level: 2,
  parentToken: "cat_pets",
  href: "/category/pets/cat",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
